module.exports = __webpack_public_path__ + "static/media/lateral-flexion-up-4.63a09266.png";